import { FieldDefinition } from "./fieldDefinitions";

export interface PatientClinicalScoreDto {
  scoreId: number;
  patientId: number;
  encounterId?: number | null;
  assessmentDate: string; // ISO string στο frontend
  scoreRemarks?: string | null;
  active: boolean;
  vasPainScore: number;
  mobilityScore: string;
}

export type PatientClinicalScoreFormData = Omit<
  PatientClinicalScoreDto,
  | "scoreId"
  | "patientId"
  | "userIdInserted"
  | "dateInserted"
  | "userIdUpdated"
  | "dateUpdated"
  | "userIdDeleted"
  | "dateDeleted"
>;
export const patientClinicalScoreFields: FieldDefinition[] = [
  {
    name: "assessmentDate",
    label: "Ημερομηνία Αξιολόγησης",
    type: "date",
    required: true,
  },
  {
    name: "vasPainScore",
    label: "Βαθμολογία Πόνου (VAS)",
    type: "number",
    required: true,
  },
  {
    name: "mobilityScore",
    label: "Βαθμολογία Κινητικότητας",
    type: "text",
    required: true,
  },
  {
    name: "scoreRemarks",
    label: "Παρατηρήσεις Αξιολόγησης",
    type: "text",
    required: false,
  },
] as const;

export const patientClinicalScoreFilters = patientClinicalScoreFields.filter(
  (f) => ["assessmentDate", "mobilityScore"].includes(f.name),
);

export const patientClinicalScoreFormData: string[] = [
  "patientId",
  "encounterId",
  "assessmentDate",
  "scoreRemarks",
  "active",
  "vasPainScore",
  "mobilityScore",
];
